import UIConfig from "@baseUI/config/UIConfig";
import MenuPopupLayout from "@baseUI/component/layout/MenuPopupLayout";
import AutospinSettingsPartContainerDesktop from "@baseUI/component/settings/AutospinSettingsPartContainerDesktop";
import SettingsSettingsPartContainerDesktop from "@baseUI/component/settings/SettingsSettingsPartContainerDesktop";
import UICreatorComponent from "@baseUI/utils/UICreatorComponent";
import UICreatorGraphics from "@baseUI/utils/UICreatorGraphics";
import BetsSettingsPartContainerDesktop from "@baseUI/component/settings/BetsSettingsPartContainerDesktop";
import InfoSettingsPartContainerDesktop from "@baseUI/component/settings/InfoSettingsPartContainerDesktop";

export default class MenuPopupLayoutDesktop extends MenuPopupLayout {

    constructor() {
        super()
    }

    setParametersSizePosition() {
        this.param = {
            shadowRect: { x: -UIConfig.totalWidth / 2, y: 0, width : UIConfig.totalWidth, height: UIConfig.totalHeight},
            panelPopupPosition: {x: -800, y: 600 },
            closeBtnPosition: {x: 1550, y: 150},
            panelBtnPosition: {x: 0, y: 200},
            listButtonsPosition: {ax: 0, bx: 0, ay: 100, by: 120},
            panelAdditionalPosition: {x: 300, y: 200}
        }

        this.paramPageCommon = {
            captionPosition: [560, 0]
        }
    }

    createButtons(panelPopup) {
        super.createButtons(panelPopup)
        UICreatorGraphics.addLine(panelPopup, 120, 250, 120, 1200)
    }

    createImplementationMenu(panelPopup) {
        const panelAdditional = UICreatorComponent.addContainer(panelPopup, this.param.panelAdditionalPosition)

        this.betPopup = new BetsSettingsPartContainerDesktop(this.paramPageCommon)
        panelAdditional.addChild(this.betPopup)
        this.betPopup.visible = true

        this.autospinPopup = new AutospinSettingsPartContainerDesktop(this.paramPageCommon)
        panelAdditional.addChild(this.autospinPopup)
        this.autospinPopup.visible = false

        this.infoPopup = new InfoSettingsPartContainerDesktop()
        panelAdditional.addChild(this.infoPopup)
        this.infoPopup.visible = false

        this.settingsPopup = new SettingsSettingsPartContainerDesktop(this.paramPageCommon)
        panelAdditional.addChild(this.settingsPopup)
        this.settingsPopup.visible = false

        this.panelAdditional = panelAdditional
    }


    updateSize(uiModelView) {
        if (this.panelBtn && this.panelAdditional) {
            //    this.panelBtn.y = -50 - uiModelView.shiftY
            //   this.panelAdditional.y = -130 - uiModelView.shiftY

        }
    }
}